import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import PDFViewer from '../../../components/PDFViewer/PDFViewer'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import { EmptyText, TitleContentBox } from '../../../components/Common/CellText'
// import PopupHandleDocument from './PopupHandleDocumentIncoming'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
//Layout
import DashboardLayout from '../../../layouts/DashboardLayout'
// Styled Component
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
} from '../../../pages/BoardReport/BoardReportDetail/BoardReportDetailPageStyled'
// Ant design
import { Dropdown, Form, Menu, message, Modal, Tag } from 'antd'
import {
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  HistoryOutlined,
  MoreOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
// PDF Viewer
import { useMediaQuery } from 'react-responsive'
import { inject, observer } from 'mobx-react'
import { DATE_FORMAT_DEFAULT } from '../../../constants'
import { blue } from '../../../color'
import utils from '../../../utils'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import moment from 'moment'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import BoardReportComment from '../BoardReportComment'
import BoardReportUpdateModal from '../BoardReportUpdate/BoardReportUpdateModal'
import ListHistoryBoardReportModal from '../../ListHistoryLog/ListHistoryBoardReportModal'
import { TextRich } from './BoardReportDetailPageStyled'
import { systemName } from '../../../config'

const { confirm } = Modal

const BoardReportDetailPage = props => {
  const [form] = Form.useForm()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    match,
    listHistoryLogStore,
    boardReportStore,
    loadingAnimationStore,
    history,
    aclStore,
  } = props

  const { documentId } = match.params
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore

  const { selectedBoardReport, boardReportCommentList } = boardReportStore

  const {
    title,
    content,
    created_at,
    user_created,
    files,
  } = selectedBoardReport

  const [isLoadingComment, setIsLoadingComment] = useState(false)
  const [attachmentForView, setAttachmentForView] = useState()
  const { code } = useParams()
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [isVisibleHistoryModal, setIsVisibleHistoryModal] = useState(false)

  const formatName = name => {
    if (!name || typeof name !== 'string') return ''
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  useEffect(() => {
    if (!files) return
    setAttachmentForView(
      files.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.fileName))
      )
    )
  }, [files])

  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.fileId}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.fileName)}
      />
    ),
    [attachmentForView]
  )

  const handleDeleteBoardReport = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await boardReportStore.deleteBoardReportByCode(code)
      history.push('/board-report')
      message.success('Xóa báo cáo thành công')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirm = () => {
    confirm({
      title: 'Bạn có muốn xóa báo cáo này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteBoardReport()
      },
    })
  }

  const menuHandleDocument = (
    <Menu>
      <Menu.Item
        icon={<EditOutlined style={{ color: blue }} />}
        onClick={() => setIsVisibleUpdateModal(true)}>
        <span style={{ color: blue }}>Chỉnh sửa báo cáo</span>
      </Menu.Item>
      <Menu.Item
        icon={<HistoryOutlined style={{ color: blue }} />}
        onClick={() => setIsVisibleHistoryModal(true)}>
        <span style={{ color: blue }}>Lịch sử</span>
      </Menu.Item>
      <Menu.Item danger onClick={showConfirm} icon={<DeleteOutlined />}>
        Xóa báo cáo
      </Menu.Item>
    </Menu>
  )

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await boardReportStore.getBoardReportByCode(code)
      } catch (err) {
        history.push('/board-report')
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()

    return () => {
      form.resetFields()
      boardReportStore.clearSelectedBoardReport()
    }
  }, [code])

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>
      <PageTitle location={props.location} title={title} showTitle={true}>
        <HeadingButtonWrapper>
          <Dropdown overlay={menuHandleDocument} trigger={['click']}>
            <span className={'btn-style'}>
              <MoreOutlined style={{ color: blue }} />
            </span>
          </Dropdown>
        </HeadingButtonWrapper>
      </PageTitle>
      <DocumentContentWrapper>
        <BlockLeft>{renderAttachment}</BlockLeft>
        <BlockRight>
          <ContentBlockWrapper>
            <TitleContentBox>Thông tin chung</TitleContentBox>
            <DocumentInfoList>
              <dt>Tiêu đề</dt>
              <dd>{title}</dd>
              <dt>Nội dung</dt>
              <dd>
                {content ? (
                  <TextRich
                    className="html-content"
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                ) : (
                  <EmptyText>Không có nội dung</EmptyText>
                )}
              </dd>
              <dt>Ngày tạo</dt>
              <dd>
                {created_at ? (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>
                      {moment(created_at).format(DATE_FORMAT_DEFAULT)}
                    </span>
                  </>
                ) : (
                  <EmptyText>Không có ngày tạo</EmptyText>
                )}
              </dd>
              <dt>Người tạo</dt>
              <dd>
                {formatName(user_created?.name_lowercase) || (
                  <EmptyText>Không có người tạo</EmptyText>
                )}
              </dd>
              <dt>Tài liệu đính kèm</dt>
              <dd>
                <div>
                  {files ? (
                    files.map(file => (
                      <FileItem
                        key={file.id}
                        file_id={file.fileId}
                        file_name={file.fileName}
                        file_type={utils.getExtensionFile(file.fileName)}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm</EmptyText>
                  )}
                </div>
              </dd>
            </DocumentInfoList>
          </ContentBlockWrapper>
          <div style={{ marginBottom: 15 }} />
          <ContentBlockWrapper style={{ position: 'relative' }}>
            <BoardReportComment setIsLoadingComment={setIsLoadingComment} />
            <SpinnerInlineComponent
              sizeSpin="small"
              isLoading={isLoadingComment}
            />
          </ContentBlockWrapper>
        </BlockRight>
      </DocumentContentWrapper>
      <BoardReportUpdateModal
        visible={isVisibleUpdateModal}
        selectedBoardReport={boardReportStore.selectedBoardReport}
        onCancel={() => setIsVisibleUpdateModal(false)}
        onSuccess={async () => {
          await boardReportStore.getBoardReportByCode(code)
          setIsVisibleUpdateModal(false)
        }}
      />
      <ListHistoryBoardReportModal
        isVisible={isVisibleHistoryModal}
        handleCloseHistory={() => setIsVisibleHistoryModal(false)}
        taskInfo={{ code }}
        type="board_report"
        fileMap={
          boardReportStore.selectedBoardReport?.files?.reduce((acc, file) => {
            acc[file.fileId] = file.fileName
            return acc
          }, {}) || {}
        }
      />
    </DashboardLayout>
  )
}

BoardReportDetailPage.propTypes = {}

export default inject(
  'commonStore',
  'internalDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'departmentStore',
  'staffStore',
  'fileStore',
  'notificationStore',
  'selectPeopleStore',
  'boardReportStore',
  'listHistoryLogStore',
  'aclStore'
)(observer(BoardReportDetailPage))
